// A default title, given to variants (I assume by Shopify), which
// we want to ignore in some cases.
export const DEFAULT_VARIANT_TITLE = "Default Title"
